export default __webpack_public_path__ + "static/media/Dhruv-santilal-cv-2022-graduate-frontend.8dae95a1.pdf";